<template>
    <square-button :icon="lineSizeIcon"
                   :tooltip-text="tooltipText"
                   flat
                   @click="onButtonClick" />
</template>

<script>
import SquareButton from '../../common/squareButton.vue'

export default {
    name: 'previewSizeChangeButton',
    components: { SquareButton },
    props: {
        /** @type {'small' | 'medium' | 'large'} */
        lineSize: String
    },
    data() {
        return {
            t_preview: Lang.langGet('Preview'),
            t_small: Lang.langGet('Small'),
            t_medium: Lang.langGet('Medium'),
            t_large: Lang.langGet('Large')
        }
    },
    computed: {
        lineSizeIcon() {
            switch (this.lineSize) {
                default:
                case 'small':
                    return 'fas fa-expand-wide'
                case 'medium':
                    return 'fas fa-arrows-maximize'
                case 'large':
                    return 'fas fa-compress-wide'
            }
        },
        /** @returns {'small' | 'medium' | 'large'} */
        nextLineSize() {
            switch (this.lineSize) {
                default:
                case 'small':
                    return 'medium'
                case 'medium':
                    return 'large'
                case 'large':
                    return 'small'
            }
        },
        t_nextLineSize() {
            switch (this.nextLineSize) {
                default:
                case 'small':
                    return this.t_small
                case 'medium':
                    return this.t_medium
                case 'large':
                    return this.t_large
            }
        },
        tooltipText() {
            return `${this.t_preview}: ${this.t_nextLineSize}`
        }
    },
    methods: {
        onButtonClick() {
            this.changeLineSize(this.nextLineSize)
        },
        /** @param {'small' | 'medium' | 'large'} newSize */
        changeLineSize(newSize) {
            this.$emit('input', newSize)
        }
    }
}
</script>
